<template>
  <div class="flex justify-center" :class='!actionsOnly ? "flex-row" : "flex-col"'>
    <div v-if='showPrompt' class="flex flex-row">
        <h1 class="heading">
          {{isFunky ? dbentry.description : "What do you want this toy to do?"}}
        </h1>
    </div>

    <slot name='info' />

    <pbc-panel v-if='showAlignment' @close='showAlignment = false' title='Alignment'>
      <transform-alignment :transform='transform'
                           :holder-data='holderData' 
                           @center='$emit("center")'
                           />
    </pbc-panel>

    <div v-else class='flex' :class='!actionsOnly ? "flex-row" : "flex-col"'>
      <div v-if='!actionsOnly' class="m-1">
      </div>

      <div class="flex self-center mb-1 mt-1"
          :class='direction === "col" ? "flex-col" : "flex-row"'>
        <pbc-button v-if='showAlignment' @click='showAlignment = true' class='main-info-button'>
          <div class="main-info-button-description flex flex-row m-0 p-0">
            <format-align-center :size='20'/>
            <span class="ml-2 mr-2">Alignment</span>
          </div>
        </pbc-button>
        <pbc-button v-if='component.type === "sprite"'  @click='onInstantEdit'  class='main-info-button pbc-primary-color'>
          <div class="main-info-button-description flex flex-row m-0 p-0">
            <image-icon :size='20' />
            <span class="ml-2 mr-2 text-xs">Edit</span>
          </div>
        </pbc-button>
        <pbc-button v-if='component.type === "text"' @click='onInstantEdit' class='main-info-button'>
          <div class="main-info-button-description flex flex-row m-0 p-0">
            <format-text />
            <span class="ml-2 mr-2 text-xs">Edit</span>
          </div>
        </pbc-button>

        <pbc-button  v-if='!isTemplateComponent && isAnimationEnabled'
                     @click='onSetDuration'
                     class='main-info-button pbc-primary-color'>

          <div class="main-info-button-description flex flex-row m-0 p-0">
            <timeline-clock-outline :size='20' />
            <span class="ml-2 mr-2 text-xs">Animate</span>
          </div>

        </pbc-button>
        <!--
        <pbc-button @click='$emit("edit")' class='main-info-button'>
          <div class="main-info-button-description flex flex-row m-0 p-0">
            <pencil :size='20' />
            <span class="ml-2 mr-2">Edit</span>
          </div>
        </pbc-button>
        -->
        <pbc-button v-if='isFunky' @click='onAddChild' class='main-info-button'>
          <div class="main-info-button-description flex flex-row m-0 p-0">
            <plus-circle />
            <span class="ml-2 mr-2">Add Toy</span>
          </div>
        </pbc-button>
      </div>
    </div>


  </div>
</template>
<script>
import { mapState } from 'vuex';
import { findDbEntry } from '@edit/tree/componentsdb.js';
import Image from '@icons/Image.vue';
import FormatText from '@icons/FormatText.vue';
import Pencil from '@icons/Pencil.vue';
import PlusCircle from '@icons/PlusCircle.vue';
import FormatAlignCenter from '@icons/FormatAlignCenter.vue';
import InformationOutline from '@icons/InformationOutline.vue';
import TransformAlignment from './TransformAlignment.vue';
import TimelineClockOutline from '@icons/TimelineClockOutline.vue';

export default {
  props: {
    transform: {
      type: Object,
      required: true
    },
    partutil: {
      type: Object,
      required: true
    },
    showPrompt: {
      type: Boolean,
      default: false
    },
    direction:{
      type: String,
      default: 'col'
    },
    holderData:{
      type: Object,
      default() {
        return {}
      }
    },
    actionsOnly: {
      type: Boolean,
      default: false
    },
    isTemplateComponent: {
      type: Boolean,
      default: false
    }
  },
  data() {
    const component = {};
    return {
      component,
      showAlignment: false
    }
  },
  components: {
    //Pencil,
    FormatText,
    PlusCircle,
    //InformationOutline,
    ImageIcon: Image,
    TransformAlignment,
    FormatAlignCenter,
    TimelineClockOutline
  },
  methods: {
    onInstantEdit() {
      const component = this.component;
      this.$emit('instant-edit', {
        component,
      });
    },
    onSetDuration() {
      const {transform,component} = this;
      this.$emit('set-duration', {
        component,
        transform
      });
    },
    onAddChild() {
      console.log('add child');
      this.$emit('instant-add');
    },
  },
  watch:{
    transform:{
      handler(nv) {
        const component = this.partutil.findComponentForTransform(this.transform);
        this.component = component;
      },
      immediate: true
    }
  },
  computed: {
    isFunky() {
      return this.dbentry.funky;
    },
    dbentry() {
      return findDbEntry(this.component);
    },
    ...mapState(['isAnimationEnabled'])
  }
}
</script>

